import React, { useState } from 'react';
import styles from '@/styles/ModalSlider.module.css';
import { CloseButton } from '@/components/common/CloseButton';
import Image from 'next/image';
interface Image {
  url: string;
  credits: string;
}
interface ImageModalProps {
  images: string[]; // Array of image URLs
  initialSlide: number; // Initial slide index
  onClose: () => void; // Function to handle modal close
}

const ImageModal = ({ images, initialSlide, onClose }: ImageModalProps) => {
  const [currentSlide, setCurrentSlide] = useState<number>(initialSlide);

  const handleNext = () => {
    setCurrentSlide(prev => (prev + 1) % images.length);
  };

  const handlePrev = () => {
    setCurrentSlide(prev => (prev - 1 + images.length) % images.length);
  };

  return (
    <div className={styles.modalOverlay}>
      {/* Close Button */}
      <div className={styles.closeButtonWrap}>
        <CloseButton
          onClick={onClose}
          size={20}
          ariaLabel='Close image viewer'
          variant='white'
          className={styles.closeButton}
        />
      </div>

      {/* Previous Button */}
      <div className={styles.prevButtonWrap}>
        <button onClick={handlePrev} className={styles.navButton}>
          <svg
            xmlns='http://www.w3.org/2000/svg'
            fill='#fff'
            className='-scale-x-100'
            height='20px'
            width='20px'
            version='1.1'
            id='Layer_1'
            viewBox='0 0 330 330'
          >
            <path
              id='XMLID_222_'
              d='M250.606,154.389l-150-149.996c-5.857-5.858-15.355-5.858-21.213,0.001  c-5.857,5.858-5.857,15.355,0.001,21.213l139.393,139.39L79.393,304.394c-5.857,5.858-5.857,15.355,0.001,21.213  C82.322,328.536,86.161,330,90,330s7.678-1.464,10.607-4.394l149.999-150.004c2.814-2.813,4.394-6.628,4.394-10.606  C255,161.018,253.42,157.202,250.606,154.389z'
            />
          </svg>
        </button>
      </div>

      {/* Next Button */}
      <div className={styles.nextButtonWrap}>
        <button onClick={handleNext} className={styles.navButton}>
          <svg
            xmlns='http://www.w3.org/2000/svg'
            fill='#fff'
            height='20px'
            width='20px'
            version='1.1'
            id='Layer_1'
            viewBox='0 0 330 330'
          >
            <path
              id='XMLID_222_'
              d='M250.606,154.389l-150-149.996c-5.857-5.858-15.355-5.858-21.213,0.001  c-5.857,5.858-5.857,15.355,0.001,21.213l139.393,139.39L79.393,304.394c-5.857,5.858-5.857,15.355,0.001,21.213  C82.322,328.536,86.161,330,90,330s7.678-1.464,10.607-4.394l149.999-150.004c2.814-2.813,4.394-6.628,4.394-10.606  C255,161.018,253.42,157.202,250.606,154.389z'
            />
          </svg>
        </button>
      </div>

      {/* Modal Content */}
      <div className={styles.modalContent}>
        <div className={styles.slider}>
          <div className={`${styles.imageContainer} h-auto w-auto`}>
            <Image
              src={images[currentSlide]}
              alt={`Slide ${currentSlide + 1}`}
              width={1000}
              height={1000}
              className={styles.sliderImage}
              style={{
                objectFit: 'contain',
                width: '100%',
                height: '100%',
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ImageModal;
